import { FormLabel, makeStyles } from '@material-ui/core';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { colors } from 'theme';

const useStyles = makeStyles({
  legend: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    paddingBottom: '0.5em',
    paddingLeft: '0.5em',
    color: colors.greyBlue,

    position: 'absolute',
    left: 0,
    bottom: 0,
  },
});

const RequiredFieldsLegend: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <FormLabel required className={classes.legend}>
      {t('requiredFieldsLegend')}
    </FormLabel>
  );
};

export default RequiredFieldsLegend;
